import React, { useEffect } from "react";
import "../css/aboutus.css";

export const AboutusBanner = () => {
  useEffect(() => {
    window.scroll(0, 0);
  });
  return (
    <div className="container">
      <div className="banner-container">
        <div className="banner-img">
          <img
            className="desktop-view"
            src="/assets/aboutusBanner.webp"
            alt="banner"
          />
          <img
            className="mobile-view"
            src="/assets/aboutusbannerMob.webp"
            alt="banner"
          />
        </div>
      </div>
    </div>
  );
};

export const AboutMission = () => {
  return (
    <div className="container">
      <div className="heading-page">
        <h1 className="home-heading">
          <img src="/assets/icons/flag.svg" alt="" />
          <span className="heading-red">OUR MISSION</span>
          <br />
        </h1>
        <span className="heading-nextline">IS CLEAR</span>
      </div>
      <div className="quote-container">
        <div className="quote-text">
          <p className="quote-upper">
            Continental Lease Advisors LLC (“CLA”) is a Chicago-based
            specialized lease and financial due diligence company, with
            additional personnel locations in Phoenix, AZ, Denver, CO, and
            Dallas, TX.
          </p>
          <p className="quote-down">
            We work with national, regional and local equity and debt investors
            in connection with their acquisition, ownership, operation,
            management, and financing of commercial properties around the United
            States. Our experience is second to none in the real estate
            consulting world, having been retained by clients on numerous
            transactions over the years ranging from single asset properties to
            large portfolios valued at more than $10 billion.
          </p>
        </div>
        <div className="quote-image-container">
          <img src="/assets/commasIcon.png" alt="quote" />
        </div>
      </div>
      <div className="services-card-container">
        <div className="services-card">
          <div className="services-card-right">
            <img src="/assets/aboutusImage1.png" alt="" />
            <span className="services-card-index"></span>
          </div>
          <div className="services-card-left">
            <h2 className="services-card-title">
              National client base /<br />
              <strong>US-based team</strong>
            </h2>
            <div className="service-card-text">
              <ul>
                <li>
                  Annually review and analyze thousands of real estate leases,
                  service contracts and management agreements
                </li>
                <li>
                  Exclusively U.S.-based team (no offshore resources) assures
                  smooth transition and consistent methodology
                </li>
                <li>
                  Partner to many corporate and retail entities with leasehold
                  interests in real estate, as well as the top providers of debt
                  across the U.S.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const AboutusClients = () => {
  return (
    <div className="container">
      <h2 className="services-card-title w-fit">
        REPRESENTATIVE
        <br />
        <strong>CLIENTS</strong>
      </h2>
      <div className="rep-clients-container">
        <div className="rep-clients-left">
          <div className="rep-clients-left-child">
            <img src="/assets/inventory.png" alt="" />
            <p className="rep-child-title">OWNERS / OPERATORS / BROKERS</p>
            <p className="rep-child-description">
              Pension Fund Advisors, Private Equity Funds, REITs, National
              brokerage firms and affiliates, Small and Mid-Size real estate
              investors
            </p>
          </div>
          <div className="rep-clients-left-child">
            <img src="/assets/free_cancellation.png" alt="" />
            <p className="rep-child-title">Lenders / Investment Banks</p>
            <p className="rep-child-description">
              National Life Companies, Wall Street Investment Banks, Other Banks
              & Mortgage Lenders
            </p>
          </div>
          <div className="rep-clients-left-child">
            <img src="/assets/corporate_fare.png" alt="" />
            <p className="rep-child-title">Corporate Tenants</p>
            <p className="rep-child-description">
              Health care companies, Law firms and professional services firms,
              Cell tower users
            </p>
          </div>
        </div>
        <div className="rep-clients-right">
          <img src="assets/rep-img.png" alt="" />
        </div>
      </div>
    </div>
  );
};
